import React, { useEffect, useState } from 'react';
import { TrendingUp, Ticket, ShoppingBag, BadgePercent } from 'lucide-react';
import { adminAPI } from '@/utils/adminApi';
import { formatCOP } from '@/utils/format';

export const KIND_LABELS = {
  welcome: 'Bienvenida (10%)',
  referral: 'Referidos (5%)',
  next_purchase: 'Regalo próxima compra (5%)',
  birthday: 'Cumpleaños mascota (10%)',
  manual: 'Manuales (admin)',
};

const Kpi = ({ icon: Icon, label, value, accent, testId }) => (
  <div className="bg-white rounded-2xl border border-[#E7E5E4] p-5" data-testid={testId}>
    <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#8BA58F] font-semibold mb-2">
      <Icon className={`w-4 h-4 ${accent}`} /> {label}
    </div>
    <p className="font-display font-bold text-2xl text-[#1C1917]">{value}</p>
  </div>
);

export const CouponStats = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminAPI.couponStats().then(setStats).catch(() => setStats({ programs: [], totals: {} }));
  }, []);

  if (!stats) return <div className="h-32 bg-white rounded-2xl border border-[#E7E5E4] animate-pulse mb-8" />;
  const t = stats.totals || {};

  return (
    <section className="mb-10" data-testid="coupon-stats">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
        <Kpi icon={Ticket} label="Cupones emitidos" value={t.issued ?? 0} accent="text-[#2A5C43]" testId="stat-issued" />
        <Kpi icon={ShoppingBag} label="Pedidos con cupón" value={t.orders ?? 0} accent="text-[#D47A4A]" testId="stat-orders" />
        <Kpi icon={BadgePercent} label="Descuento otorgado" value={formatCOP(t.discount_total || 0)} accent="text-[#B45309]" testId="stat-discount" />
        <Kpi icon={TrendingUp} label="Ventas generadas" value={formatCOP(t.revenue_total || 0)} accent="text-[#2A5C43]" testId="stat-revenue" />
      </div>
      <div className="bg-white rounded-2xl border border-[#E7E5E4] overflow-x-auto">
        <table className="w-full text-sm" data-testid="coupon-stats-table">
          <thead>
            <tr className="text-left text-[11px] uppercase tracking-widest text-[#8BA58F] border-b border-[#F5F5F4]">
              <th className="px-5 py-3 font-semibold">Programa</th>
              <th className="px-3 py-3 font-semibold text-right">Emitidos</th>
              <th className="px-3 py-3 font-semibold text-right">Usados</th>
              <th className="px-3 py-3 font-semibold text-right">Vigentes</th>
              <th className="px-3 py-3 font-semibold text-right">Vencidos</th>
              <th className="px-3 py-3 font-semibold text-right">Tasa de uso</th>
              <th className="px-3 py-3 font-semibold text-right">Descuento</th>
              <th className="px-5 py-3 font-semibold text-right">Ventas</th>
            </tr>
          </thead>
          <tbody>
            {stats.programs.map((p) => (
              <tr key={p.kind} className="border-b border-[#F5F5F4] last:border-0" data-testid={`stat-row-${p.kind}`}>
                <td className="px-5 py-3 font-semibold text-[#1C1917]">{KIND_LABELS[p.kind] || p.kind}</td>
                <td className="px-3 py-3 text-right text-[#57534E]">{p.issued}</td>
                <td className="px-3 py-3 text-right font-semibold text-[#2A5C43]">{p.used}</td>
                <td className="px-3 py-3 text-right text-[#57534E]">{p.active}</td>
                <td className="px-3 py-3 text-right text-[#57534E]">{p.expired}</td>
                <td className="px-3 py-3 text-right text-[#57534E]">{p.issued ? `${Math.round((p.used / p.issued) * 100)}%` : '—'}</td>
                <td className="px-3 py-3 text-right text-[#B45309] font-semibold">{formatCOP(p.discount_total)}</td>
                <td className="px-5 py-3 text-right text-[#1C1917] font-semibold">{formatCOP(p.revenue_total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
